"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var R = _interopRequireWildcard(require("ramda"));
var _checkbox = _interopRequireDefault(require("../../checkbox"));
var _label = _interopRequireDefault(require("../../label"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FilterCollapseItem = function FilterCollapseItem(_ref) {
  var item = _ref.item,
    selectedItems = _ref.selectedItems,
    virtualized = _ref.virtualized,
    _onChange = _ref.onChange,
    subItem = _ref.subItem,
    style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("li", {
    key: "".concat(item.title).concat(subItem.value),
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
    id: "".concat(item.title, "_").concat(subItem.value),
    checked: R.find(function (element) {
      return element === subItem.value;
    }, R.prop(item.key, selectedItems) || []) || false,
    onChange: function onChange(event, value) {
      return _onChange(event, item, subItem, value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_label["default"], {
    htmlFor: "".concat(item.title, "_").concat(subItem.value),
    className: virtualized ? 'item-text-label' : ''
  }, /*#__PURE__*/_react["default"].createElement("span", null, subItem.value), " (", /*#__PURE__*/_react["default"].createElement("strong", null, subItem.count), ")"));
};
FilterCollapseItem.propTypes = {
  item: _propTypes["default"].shape({
    title: _propTypes["default"].string,
    key: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
  }).isRequired,
  subItem: _propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    count: _propTypes["default"].number
  }).isRequired,
  selectedItems: _propTypes["default"].shape({}),
  virtualized: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  style: _propTypes["default"].shape({})
};
FilterCollapseItem.defaultProps = {
  selectedItems: {},
  virtualized: false,
  onChange: _utils.noop,
  style: null
};
var _default = exports["default"] = FilterCollapseItem;